import request from '@/utilities/request'

// 学校列表
export function schoolList(params) {
    return request({
        url:"school",
        method:"get",
        params
    })
}

// 学校类型
export function schoolType() {
    return request({
      url: 'school/type',
      method: 'get',
      params:{  }
    })
}

// 我的学校类型
export function mySchoolType(school_id) {
    return request({
      url: 'school/mytype',
      method: 'get',
      params:{ school_id:school_id }
    })
}


// 老师添加班级
export function addClass(data){
    return request({
        url:'teacher/class',
        method:'post',
        data
    })
}


// 班级学生列表
export function studentListByClass(params) {
    return request({
      url: 'teacher/student',
      method: 'get',
      params
    })
}

// 添加学生
export function studentAdd(data){
    return request({
        url:'teacher/student',
        method:'post',
        data
    })
}

// 编辑学生
export function studentEdit(data){
    return request({
        url:'teacher/student/'+data.id,
        method:'put',
        data
    })
}

// 删除学生
export function studentDel(id){
    return request({
        url:"teacher/student/"+id,
        method:"delete"
    })
}

// 批量删除学生 teacher/studentBatchDel
export function studentBatchDel(data){
    return request({
        url:"teacher/studentBatchDel",
        method:"delete",
        data
    })
}

// 学校设备列表
export function deviceList(params) {
    return request({
      url: 'school/device',
      method: 'get',
      params
    })
}

// 添加设备
export function deviceAdd(data){
    return request({
        url:'school/device',
        method:'post',
        data
    })
}

// 编辑设备
export function deviceEdit(data){
    return request({
        url:'school/device/'+data.id,
        method:'put',
        data
    })
}

// 删除设备
export function deviceDel(id){
    return request({
        url:"school/device/"+id,
        method:"delete"
    })
}

// 设备绑定学生
export function deviceBindStudent(data){
    return request({
        url:"school/deviceBindStudent",
        method:"post",
        data
    })
}

// 设备解绑学生
export function deviceUnbindStudent(data){
    return request({
        url:"school/deviceUnbindStudent",
        method:"post",
        data
    })
}

// 批量设备解绑学生
export function deviceBatchUnbindStudent(data){
    return request({
        url:"school/deviceBatchUnbindStudent",
        method:"post",
        data
    })
}

// 批量删除设备
export function deviceBatchDelete(data){
    return request({
        url:"school/deviceBatchDelete",
        method:"post",
        data
    })
}


// 绑定了设备的学生列表
export function deviceStudents(class_id){
    return request({
        url:"school/deviceStudents",
        method:"get",
        params:{class_id:class_id}
    })
}

// 老师的班级列表
export function teacherClass(){
    return request({
        url:"teacher/class",
        method:"get"
    })
}

// 获取学校的网关设备
export function schoolGateway(school_id){
    return request({
        url:"school/gateway",
        method:"get",
        params:{school_id:school_id}
    })
}

// 批量导入学生
export function uploadStudents(data){
    return request({
        url:"school/import/student",
        method:"post",
        data
    })
}

// 批量导入设备
export function uploadDevices(data){
    return request({
        url:"school/import/device",
        method:"post",
        data
    })
}

// 积分标准添加
export function scoreAdd(data){
    return request({
        url:"school/score",
        method:"post",
        data
    })
}

// 积分标准列表
export function scoreList(school_id){
    return request({
        url:"school/score",
        method:"get",
        params:{school_id:school_id}
    })
}

// 保存学校积分分值 school/scoreSave
export function scoreSave(data){
    return request({
        url:"school/scoreSave",
        method:"post",
        data
    })
}
// 删除年级积分标准 school/delClassType
export function delClassType(data){
    return request({
        url:"school/delClassType",
        method:"post",
        data
    })
}

// 设置评级
export function updateScoreLevel(data){
    return request({
        url:"school/saveLevel",
        method:"post",
        data
    })
}

// 获取评级 school/getLevel
export function getScoreLevel(school_id){
    return request({
        url:"school/getLevel",
        method:"get",
        params:{school_id:school_id}
    })
}

// 看板 teacher/controller
export function controller(params){
    return request({
        url:"teacher/controller",
        method:"get",
        params
    })
}

//teacher/classMatchLog 班级赛事成绩记录
export function classMatchLog(params){
    return request({
        url:"teacher/classMatchLog",
        method:"get",
        params
    })
}

// 看板
export function screenInfo(params){
    return request({
        url:"screen/info/v2",
        method:"get",
        params
    })
}